export default __webpack_public_path__ + "static/bscscan-8e120ef4a175a87d10d058eddfa5c0ea.svg";